import { ObservablePoint } from 'pixi.js';
import SpineAnimation from '../views/SpineAnimation';
import Layout from './Layout';

export default class SpineUtils {
    /**
     * Parse and apply scaleMultiplier prop from spine animation config file
     * @param spineAnim
     * @param defaultScale
     */
    static applyConfigScaleMultiplier = (spineAnim: SpineAnimation, defaultScale: {x: number, y:number}) => {
        if (spineAnim && defaultScale) {

            if (spineAnim.animConfig.scaleMultiplier && Array.isArray(spineAnim.animConfig.scaleMultiplier)) {
                const scaleConfig = spineAnim.animConfig.scaleMultiplier.find(c => spineAnim.state.tracks.some(t => c.animation === (t as any).animation.name));

                if (scaleConfig) {
                    spineAnim.scale.set(
                        scaleConfig.x ? defaultScale.x * scaleConfig.x : defaultScale.x,
                        scaleConfig.y ? defaultScale.y * scaleConfig.y : defaultScale.y
                    )
                } else {
                    spineAnim.scale.set(defaultScale.x, defaultScale.y);
                }
            } else if (spineAnim.animConfig.scaleMultiplier) {
                spineAnim.scale.set(
                    spineAnim.animConfig.scaleMultiplier["x"] ? defaultScale.x * spineAnim.animConfig.scaleMultiplier["x"] : defaultScale.x,
                    spineAnim.animConfig.scaleMultiplier["y"] ? defaultScale.y * spineAnim.animConfig.scaleMultiplier["y"] : defaultScale.y
                )
            } else {
                spineAnim.scale.set(defaultScale.x, defaultScale.y);
            }

        }
    }
}
